import type React from 'react';

import { useAppState } from '../../../AppStateProvider';
import { AppMode } from '../../../services/appStore';

export const UserSettingsGuard = ({ children }: React.PropsWithChildren) => {
  const { settingsStorage, mode } = useAppState();

  if (!settingsStorage?.settingsWereSet && mode !== AppMode.Standalone) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
